<template>
  <div class="content2">
    <div class="right">
      <div class="toptit">
        <span>关于我们</span>
        <img src="../../assets/About/about.png" alt="" />
      </div>
      <div class="more">
        <span>
          北京云信观远信息技术有限公司注册资金1001万，公司专注于机房数智电源产品研发，先后取得质量管理体系认证ISO9001、环境管理体系认证ISO14001、职业健康安全管理体系认证ISO45001、信息安全管理体系认证ISO27001、信息技术服务管理体系认证ISO20000、CMMI3认证。
          主要产品与业务：基站防窃电系统，远程抄表系统，蓄电池管理系统，铅酸电池修复业务。
        </span>
      </div>
      <button class="gomore" @click="gomore">查看详情</button>
    </div>
    <div class="left">
        <img src="../../assets/About/lou.png" alt="">
    </div>
  </div>
</template>
<script>
export default {
  methods:{
    gomore(){
        this.$router.push('/aboutus')
    }
  }
}
</script>
<style lang="less" scoped>
.content2 {
  width: 80%;
  height: 650px;
  margin: auto;
  // border: 1px solid red;
  display: flex;
  align-items: center;
  //   justify-content: space-between;
  .right {
    width: 60%;
    height: 550px;
    // border: 1px solid red;
    display: flex;
    flex-direction: column;
    align-items: center;
    .toptit {
      display: flex;
      flex-direction: column;
      //   margin-right: 500px;
    //   border: 1px solid red;
      margin-top: 50px;
      span {
        font-size: 40px;
        font-family: NotoSansHans-Regular, NotoSansHans;
        font-weight: 400;
        color: #333333;
      }
      img {
        width: 349px;
        height: 66px;
        margin-top: -20px;
      }
    }
    .more {
      width: 500px;
      span {
        font-size: 18px;
        font-family: NotoSansHans-Regular, NotoSansHans;
        font-weight: 400;
        color: #323232;
        line-height: 40px;
      }
    }
    .gomore {
      width: 175px;
      height: 44px;
      background: #f1bb2b;
      opacity: 1;
      border: none;
      font-size: 16px;
      font-family: NotoSansHans-Regular, NotoSansHans;
      font-weight: 400;
      color: #ffffff;
      margin-top: 50px;
      cursor: pointer;
    }
  }
  .left {
    width: 40%;
    height: 550px;
    // border: 1px solid blue;
    img {
        width: 100%;
        height: 550px;
        margin-top: 49px;
    }
  }
}
</style>